import { useContext, useEffect, useState } from 'react';
import { Button, CircularProgress, TextField, ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import styles from './styles.module.css'
import ForgetImage from '../../assets/forget.png'
import Logo from '../../assets/Logo.png'
import { contextSnack } from '../../context';
import { forgetSchema } from './validator';
import Axios from 'axios'

export default function Forget() {
  const [email, setEmail] = useState<string>("")
  const [emailError, setEmailError] = useState<string>("")
  const [loading, setLoading] = useState(false)
  const { showSnackbar, profile, setProfile } = useContext(contextSnack)

  const casesErrors = {
    "email": setEmailError,
  }

  useEffect(() => {
    (() => {
      document.title = "Ayude - Esqueci minha senha"
    })()
  }, [])

  const execute = async () => {
    setLoading(true)
    await forgetSchema.validate({
      email,
    }, {
      abortEarly: false,
    }).then(async () => {
      await Axios.post(process.env.REACT_APP_AUTH_API + '/redefine-password', {
        profile: profile,
        username: email,
        frontend: "https://login.ayude.com.br",
        location: "/reset"
      }).then((res) => {
        console.log(res)
        showSnackbar({
          message: `E-mail de recuperação enviado para ${email}`,
          severity: "success"
        })
      }).catch((err) => {
        showSnackbar({
          message: err.response.data.error,
          severity: "error"
        })
      }).finally(() => {
        setLoading(false)
      })
    }).catch((err) => {
      for (let _e of err.inner) {
        casesErrors[_e.path as "email"](_e.message)
      }
    }).finally(() => setLoading(false))
  }

  return (
    <div className="container">
      <div className="image">
        <img src={ForgetImage} alt="ForgetImage" />
      </div>
      <div className="content">
        <div className="box">
          <img src={Logo} alt="Logo Ayude" />
          <div className="containerText">
            <p className="wellcome">Esqueceu a senha?</p>
            <p className="instruction">Para alterar sua senha, informe seu e-mail de acesso. Você receberá um e-mail para digitar sua nova senha.</p>
          </div>
          <div className="form">
            <ToggleButtonGroup
              color='primary'
              value={profile}
              onChange={(e, _profile) => {
                if (_profile) {
                  setProfile(_profile)
                }
              }}
              fullWidth
              exclusive
            >
              <ToggleButton className='toggleButton' value="pdv">
                <Tooltip title={<p className="tooltip">Este novo acesso MATRIZ substitui o ANTIGO acesso PDV (pdv.trocacreditos.com.br)</p>}>
                  <span>Matriz (PDV)</span>
                </Tooltip>
              </ToggleButton>


              <ToggleButton className='toggleButton' value="sales_counter">
                <Tooltip title={<p className="tooltip">Este novo acesso FILIAL substitui o ANTIGO acesso BALCÃO (smartbank.trocacreditos.com.br)</p>}>
                  <span>Filial (Balcão)</span>
                </Tooltip>
              </ToggleButton>
            </ToggleButtonGroup>
            <TextField
              className={styles.emailInput}
              label={email ? "E-mail" : ""}
              placeholder="E-mail"
              type='email'
              sx={{
                '& ::placeholder': {
                  fontSize: '1.5rem',
                }
              }}
              inputProps={{
                style: {
                  fontSize: '1.5rem',
                }
              }}
              fullWidth
              value={email}
              onChange={(e) => {
                if (emailError) {
                  setEmailError('')
                }
                setEmail(e.target.value)
              }}
              error={!!emailError}
              helperText={emailError}
              FormHelperTextProps={{
                style: {
                  fontSize: '1.2rem'
                }
              }}
            />
          </div>
          <Button
            variant='contained'
            fullWidth
            color='primary'
            onClick={execute}
            endIcon={loading && <CircularProgress style={{ color: "#fff" }} size={24} />}
          >Enviar</Button>
        </div>
      </div>
    </div>
  );
}